
import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { Router } from 'react-router-dom';
import {persistStore, createTransform} from 'redux-persist';
import CryptoJS from 'crypto-js';
import I18n from 'redux-i18n';
import AppRoutes from './router';
import { createBrowserHistory } from 'history';
import translations from '../constants/translations';
import ConfigureStore from './configure-store';
import '../app.scss';

window.jQuery = window.$ = $;
import 'bootstrap';

let store = ConfigureStore();

class App extends React.Component {
  constructor(prop) {
    super(prop);
    this.state = {
      loading: true
    };
  }

  componentWillMount() {
    // store.dispatch({type: 'REDUX_I18N_SET_TRANSLATIONS', translations});
    const encryptTransform = createTransform(
      (inboundState) => {
        const encrypted = CryptoJS.AES.encrypt(JSON.stringify(inboundState), 'OBAASH7HOQCFOYYD');
        return encrypted.toString();
      },
      (outboundState) => {
        const decrypted = CryptoJS.AES.decrypt(outboundState, 'OBAASH7HOQCFOYYD');
        return JSON.parse(decrypted.toString(CryptoJS.enc.Utf8));
      },
      { whitelist: ['LotStore', 'i18nState'] }
    );

    persistStore(store, {
      transforms: [encryptTransform],
      whitelist: ['LotStore', 'i18nState']
    }, () => {
      this.setState({ loading: false });

      store.dispatch({type: 'REDUX_I18N_SET_TRANSLATIONS', translations});
    });
  }

  render() {
    let history = createBrowserHistory({ basename: '/' });

    if (this.state.loading) {
      return '';
    }

    return (
      <Provider store={store}>
        <I18n translations={{}} useReducer>
          <Router history={history}>
            <AppRoutes />
          </Router>
        </I18n>
      </Provider>
    );
  }

}

ReactDOM.render(<App />, document.getElementById('root'));



// WEBPACK FOOTER //
// ./src/portal_homeowner/index.js